<div class="flex flex-col items-stretch overflow-hidden"
    [ngClass]="{'border border-zen-neutralp90 bg-white rounded-lg':!chartExport}" id="enpsAnalysis_chart">
    @if (chartExport) {
    <p class="text-zen-primaryDark text-2xl font-bold">{{'txtENPSScore' | translate:language:ModuleNames.Engagement}}
    </p>
    }@else {
    <div class="w-full flex flex-row justify-between items-center px-6 py-2 border-b border-zen-neutralp90 h-14">
        <p class="text-zen text-sm font-medium">{{'txtENPSScore' | translate:language:ModuleNames.Engagement}}</p>
        <zen-menu>
            <button trigger [zenButton]="{type:ZenButtonType.Ghost, icon:true, size:10}">
                <i class="fa-regular fa-ellipsis"></i>
            </button>
            <a (click)="downloadExcel()" zenMenuItem><i class="fa-solid fa-table"></i>
                {{ "txt_RawData_453" | translate:language:ModuleNames.Shared }}
            </a>
            <a (click)="downloadChart('enpsAnalysis_chart')" zenMenuItem><i class="fa-solid fa-download"></i>
                {{ "txt_Export_229" | translate:language:ModuleNames.Shared }}
            </a>
        </zen-menu>
    </div>
    }

    <div class="flex flex-col gap-4 pt-8 pb-10 items-stretch" [ngClass]="chartExport ? 'px-0':'px-8'">
        <div class="flex flex-row w-full items-stretch gap-6">
            <div class="flex flex-col items-stretch gap-2 w-40 min-w-40">
                <div
                    class="w-full h-12 rounded-lg bg-zen-neutralp95 flex flex-row items-center justify-between text-zen-primaryLight text-base" [ngClass]="chartExport ? 'px-4':'px-2'">
                    <p class="text-xs text-zen-primaryLight font-medium min-w-5">
                        @if (chartExport) {
                        {{'txtOverall' | translate:language:ModuleNames.Engagement}}
                        }
                    </p>
                    <p class="text-zen-primaryDark font-medium text-2xl">
                        {{enpsAnalysis?.OverallPercentage | number:'1.1-1'}}%</p>
                    @let enpsInfoKey = enpsAnalysis?.OverallPercentage > 0 ? 'ENPS_INFO_POS': enpsAnalysis?.OverallPercentage == 0 ?
                                    'ENPS_INFO_NEU': 'ENPS_INFO_NEG';
                    @if (!chartExport) {
                    <i [matTooltip]="enpsInfoKey | translate:language:ModuleNames.Engagement"
                        class="flex justify-center items-center min-w-5 fa-regular fa-circle-info"></i>
                    }
                </div>
                <ng-content select="[benchmark]"></ng-content>
            </div>
            <div class="flex flex-col items-stretch w-full p-4 border border-zen-neutralp90 rounded gap-4">
                <div class="flex flex-row w-full items-center gap-3 text-sm">
                    <p class="text-zen min-w-20">{{'txtPromoters' | translate:language:ModuleNames.Engagement}}</p>
                    <div class="flex flex-row w-full rounded overflow-hidden bg-zen-semanticGreen/10 items-stretch h-6">
                        <div class="bg-zen-semanticGreen duration-300 transition-all ease-expo"
                            [style.width.%]="enpsAnalysis?.PromotersPercentage"></div>
                    </div>
                    <div class="flex flex-row items-center justify-start gap-1 min-w-[5.5rem]">
                        <p class="font-medium text-zen-primaryDark">{{enpsAnalysis?.PromotersCount}}</p>
                        <p class="text-zen-primaryLight">({{enpsAnalysis?.PromotersPercentage | number:'1.1-1'}}%)</p>
                    </div>
                </div>
                <div class="flex flex-row w-full items-center gap-3 text-sm">
                    <p class="text-zen min-w-20">{{'txtPassives' | translate:language:ModuleNames.Engagement}}</p>
                    <div
                        class="flex flex-row w-full rounded overflow-hidden bg-zen-semanticOrange/10 items-stretch h-6">
                        <div class="bg-zen-semanticOrange duration-300 transition-all ease-expo"
                            [style.width.%]="enpsAnalysis?.PassivesPercentage"></div>
                    </div>
                    <div class="flex flex-row items-center justify-start gap-1 min-w-[5.5rem]">
                        <p class="font-medium text-zen-primaryDark">{{enpsAnalysis?.PassivesCount}}</p>
                        <p class="text-zen-primaryLight">({{enpsAnalysis?.PassivesPercentage | number:'1.1-1'}}%)</p>
                    </div>
                </div>
                <div class="flex flex-row w-full items-center gap-3 text-sm">
                    <p class="text-zen min-w-20">{{'txtDetractors' | translate:language:ModuleNames.Engagement}}</p>
                    <div class="flex flex-row w-full rounded overflow-hidden bg-zen-semanticRed/10 items-stretch h-6">
                        <div class="bg-zen-semanticRed duration-300 transition-all ease-expo"
                            [style.width.%]="enpsAnalysis?.DetractorsPercentage"></div>
                    </div>
                    <div class="flex flex-row items-center justify-start gap-1 min-w-[5.5rem]">
                        <p class="font-medium text-zen-primaryDark">{{enpsAnalysis?.DetractorsCount}}</p>
                        <p class="text-zen-primaryLight">({{enpsAnalysis?.DetractorsPercentage | number:'1.1-1'}}%)</p>
                    </div>
                </div>
            </div>
        </div>
        @if (!chartExport) {
        <div class="flex flex-row w-full justify-center items-center">
            <div class="flex flex-row items-center gap-0.5 btn text-exp text-xs"
                (click)="showBreakdown = !showBreakdown">
                <p>{{(showBreakdown ? 'txt_HideBreak_950' : 'txt_ShowBreak_712') |
                    translate:language:ModuleNames.Engagement}}</p>
                <i class="fa-regular fa-angle-down min-w-5 flex justify-center items-center transition-all duration-300 ease-expo"
                    [ngClass]="{'rotate-180': showBreakdown}"></i>
            </div>
        </div>
        }
        <div class="w-full grid transition-all duration-300 ease-expo"
            [style.grid-template-rows]="(showBreakdown || chartExport) ? '1fr' : '0fr'"
            [ngClass]="(showBreakdown || chartExport) ? 'mt-0' : '-mt-4'">
            <div class="overflow-hidden">
                <div class="w-full grid gap-4"
                    [ngClass]="chartExport ? '' : 'border border-zen-neutralp90 rounded p-4'">
                    @if (chartExport) {
                    <p class="text-sm text-zen font-medium mt-2">{{'txt_eNPSScore_947' |
                        translate:language:ModuleNames.Engagement}} <span class="font-normal">({{criteria.name |
                            extract:language}})</span></p>
                    }@else {
                    <div class="flex flex-row w-full justify-between h-8 items-center col-span-1">
                        <p class="uppercase font-medium text-zen text-xs">{{'ScoreByCriteria' |
                            translate:language:ModuleNames.Shared}}</p>
                        <ng-content></ng-content>
                    </div>
                    }
                    @if(enpsAnalysis.ChartData?.length){
                    <div class="w-full flex flex-col gap-1 items-stretch col-span-1"
                        [@listAnimation]="enpsAnalysis.ChartData.length">
                        <ng-container [ngTemplateOutlet]="enpsHeader"></ng-container>
                        @if(chartExport){
                        @for (enpsData of enpsAnalysis.ChartData | slice:0:FIRST_PAGE_ROWS; track $index) {
                        <ng-container [ngTemplateOutlet]="enpsRow"
                            [ngTemplateOutletContext]="{$implicit:enpsData}"></ng-container>
                        }
                        }@else {
                        @for (enpsData of enpsAnalysis.ChartData; track $index) {
                        <ng-container [ngTemplateOutlet]="enpsRow"
                            [ngTemplateOutletContext]="{$implicit:enpsData}"></ng-container>
                        }

                        }
                    </div>
                    }@else {
                    <div @child5
                        class="w-full flex flex-col items-center justify-center gap-4 px-8 py-14 border border-zen-neutralp90 bg-zen bg-opacity-10 rounded-lg">
                        <i class="fa-light fa-chart-column text-5xl text-zen-neutralp70"></i>
                        <h2 class="text-lg font-medium text-center text-zen-dark">
                            {{ "txt_Insuffici_103" | translate:language:ModuleNames.Engagement }}
                        </h2>
                        <p class="text-sm text-center text-primary-light">
                            {{ "txt_Theselect_919" | translate:language:ModuleNames.Engagement }}
                        </p>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    @if (enpsAnalysis.ChartData.length > FIRST_PAGE_ROWS && chartExport) {
    <div class="w-full col-span-1 block space-y-1">
        @for (enpsData of enpsAnalysis.ChartData | slice:FIRST_PAGE_ROWS; track $index) {
        @if ($index % SUBSEQUENT_PAGE_ROWS === 0) {
        <span class="break-before !mt-16"></span>
        <ng-container [ngTemplateOutlet]="enpsHeader"></ng-container>
        }
        <ng-container [ngTemplateOutlet]="enpsRow" [ngTemplateOutletContext]="{$implicit:enpsData}"></ng-container>
        }
    </div>
    }

</div>

<ng-template #enpsHeader>
    <div class="flex flex-row w-full items-center gap-2 text-xxs text-zen-primaryLight">
        <div [ngClass]="chartExport ? 'w-[11.25rem] min-w-[11.25rem]':'w-50 min-w-[12.5rem]'"></div>
        <div class="w-full flex flex-row items-center h-6 gap-1">
            <p class="w-full text-center">{{'txtPromoters' |
                translate:language:ModuleNames.Engagement}}</p>
            <p class="w-full text-center">{{'txtPassives' |
                translate:language:ModuleNames.Engagement}}</p>
            <p class="w-full text-center">{{'txtDetractors' |
                translate:language:ModuleNames.Engagement}}
            </p>
        </div>
        <div class="w-14 min-w-14 h-6 flex flex-row justify-center items-center">
            <p>{{'txtOverall' | translate:language:ModuleNames.Engagement}}</p>
        </div>
    </div>
</ng-template>

<ng-template #enpsRow let-enpsData>
    <div class="flex flex-row w-full items-center text-xxs text-zen-primaryLight" [ngClass]="chartExport ? 'gap-3':'gap-2'">
        <div [ngClass]="chartExport ? 'w-[11.25rem] min-w-[11.25rem] justify-start':'w-50 min-w-[12.5rem]'"
            class="flex flex-row items-center min-h-6 h-fit">
            <p class="text-xs w-full">{{enpsData.Category}}</p>
        </div>
        <div class="w-full flex flex-row items-center h-6 gap-1">
            <div class="flex flex-row justify-center items-center w-full h-6 bg-zen-semanticGreen/10">
                <p class="text-xs text-zen">{{enpsData.Promoters}} ({{enpsData.PromotersPercentage |
                    number:'1.1-1'}}%)
                </p>
            </div>
            <div class="flex flex-row justify-center items-center w-full h-6 bg-zen-semanticOrange/10">
                <p class="text-xs text-zen">{{enpsData.Passives}} ({{enpsData.PassivesPercentage |
                    number:'1.1-1'}}%)
                </p>
            </div>
            <div class="flex flex-row justify-center items-center w-full h-6 bg-zen-semanticRed/10">
                <p class="text-xs text-zen">{{enpsData.Detractors}} ({{enpsData.DetractorsPercentage
                    | number:'1.1-1'}}%)
                </p>
            </div>
        </div>
        <div class="w-14 min-w-14 h-6 flex flex-row justify-center items-center text-xs">
            <p>{{enpsData.value | number:'1.1-1'}}%</p>
        </div>
    </div>
</ng-template>



<!-- 
<div *ngIf="!chartData.export" class="flex flex-col gap-6 items-stretch p-5  bg-white rounded-md">

    <div class="flex flex-col">
        <div class="flex flex-row justify-between">
            <h5 class="text-zen text-2xl font-medium">
                {{'txtENPS'| translate:language:ModuleNames.Engagement}}
            </h5>

            <div class="flex flex-row">
                <i (click)="changeSeries()" zenButton styles="ghost icon-10" class="fa-regular "
                    [ngClass]="chartData?.type != SeriesType.Column?'fa-chart-column':'fa-chart-bar'"></i>
                <div class="align-self-end">

                    <i [ZMenuTriggerFor]="menu"
                        class="fal font-normal fa-ellipsis-h h-9 w-9 leading-9 bg-white text-zen rounded-full  btn text-center"></i>
                    <z-menu #menu>
                        <menuItems>
                            <a (click)="downloadExcel()" MenuItem><i class="fa-solid fa-table"></i>
                                {{ "txt_RawData_453" | translate:language:ModuleNames.Shared }}
                            </a>
                            <a (click)="downloadChart('enpsAnalysis_chart')" MenuItem><i
                                    class="fa-solid fa-download"></i>
                                {{ "txt_Export_229" | translate:language:ModuleNames.Shared }}
                            </a>
                        </menuItems>
                    </z-menu>
                </div>
            </div>

        </div>
        <div [@child31] class="py-2">
            <mat-divider></mat-divider>
        </div>
    </div>


    <div class="flex flex-row items-stretch gap-6"
        *ngIf="enpsAnalysis?.OverallPercentage ||enpsAnalysis?.OverallPercentage == 0 ">
        <div class="flex flex-row gap-8">
            <div class="flex flex-row items-center gap-2 text-4xl">
                <i class="fa-regular fa-gauge-high text-zen text-opacity-60 "></i>
                <h5 class="text-zen font-medium"> {{enpsAnalysis?.OverallPercentage | number:'1.1-1'}}%</h5>
            </div>
        </div>
        <span class="border-r border-zen border-opacity-10"></span>
        <ng-content select="[benchmark]"></ng-content>

        <div class="flex flex-row items-stretch justify-end w-full gap-5">
            <div class="flex flex-row justify-between gap-4 items-center">
                <div class="flex flex-row items-center gap-1.5">
                    <span class="bg-zen-semanticGreen rounded-sm h-3 w-4"></span>
                    <h5 class="text-zen-primaryLight text-xs capitalize">{{'Promoters'|
                        translate:language:ModuleNames.Shared}}</h5>
                </div>
                <h5 class="text-xs font-medium text-zen-primaryLight">{{enpsAnalysis?.PromotersCount}}
                    ({{enpsAnalysis?.PromotersPercentage | number:'1.1-1'}}%)</h5>
            </div>
            <span class="border-r border-zen border-opacity-10"></span>
            <div class="flex flex-row justify-between gap-4 items-center">
                <div class="flex flex-row items-center gap-1.5">
                    <span class="bg-zen-orange rounded-sm h-3 w-4"></span>
                    <h5 class="text-zen-primaryLight text-xs capitalize">{{'Passives'|
                        translate:language:ModuleNames.Shared}}</h5>
                </div>
                <h5 class="text-xs font-medium text-zen-primaryLight">{{enpsAnalysis?.PassivesCount}}
                    ({{enpsAnalysis?.PassivesPercentage | number:'1.1-1'}}%)</h5>
            </div>
            <span class="border-r border-zen border-opacity-10"></span>

            <div class="flex flex-row justify-between gap-4 items-center">
                <div class="flex flex-row items-center gap-1.5">
                    <span class="bg-zen-red rounded-sm h-3 w-4"></span>
                    <h5 class="text-zen-primaryLight text-xs capitalize">{{'Detractors'|
                        translate:language:ModuleNames.Shared}}</h5>
                </div>
                <h5 class="text-xs font-medium text-zen-primaryLight">{{enpsAnalysis?.DetractorsCount}}
                    ({{enpsAnalysis?.DetractorsPercentage | number:'1.1-1'}}%)</h5>
            </div>

        </div>
    </div>
    <div [@child31]>
        <mat-divider></mat-divider>
    </div>
    <div class="flex flex-col items-stretch bg-white rounded-sm gap-5">
        <div class="flex flex-row justify-between items-center">
            <h5 class="text-xs text-zen font-medium uppercase">
                {{'ScoreByCriteria'|translate:language:ModuleNames.Shared}}</h5>
            <div class="flex flex-row justify-end gap-2">
            </div>
        </div>
        <zen-chart *ngIf="chartData && enpsAnalysis.ChartData?.length else noData"
            [renderAs]="chartData.export?'svg':'canvas'" [data]="chartData"></zen-chart>
        <ng-template #noData>
            <div class="w-full flex flex-col items-center justify-center gap-4 
             px-8 py-14 border border-zen-neutralp90 bg-zen bg-opacity-10 rounded-lg">
                <i class="fa-light fa-chart-column text-5xl text-zen-neutralp70"></i>

                <h2 class="text-lg font-medium text-center text-zen-dark">
                    {{ "txt_Insuffici_103" | translate:language:ModuleNames.Engagement }}
                </h2>

                <p class="text-sm text-center text-primary-light">
                    {{ "txt_Theselect_919" | translate:language:ModuleNames.Engagement }}
                </p>
            </div>

        </ng-template>
    </div>
</div> -->

<!-- <div id="enpsAnalysis_chart" class="block">

    <h5 *ngIf="chartData.export" class="pb-5 text-zen font-semibold text-2xl">{{"enpsScore" |
        translate:language:ModuleNames.Shared}}
    </h5>
    <div id="enpsAnalysis_chart" class="block py-5 rounded   shadow-sm bg-white exportView" *ngIf="chartData.export">
        <div class="block pb-4">
            <div class="flex flex-row justify-evenly gap-4">
                <div class="flex-1">
                    <ng-container
                        *ngTemplateOutlet="cardTemplate; context:{$implicit:'overall', secondTitle:'',icon:'fa-gauge-high text-zen ', value:(enpsAnalysis?.OverallPercentage | number:'1.1-1' )+'%'}"></ng-container>
                </div>
                <div class="flex-1">
                    <ng-container
                        *ngTemplateOutlet="cardTemplate; context:{$implicit:'Promoters', secondTitle:'',icon:'fa-face-smile text-zen-green', value:enpsAnalysis?.PromotersCount, secondValue:enpsAnalysis?.PromotersPercentage | number:'1.1-1'}"></ng-container>
                </div>

                <div class="flex-1">
                    <ng-container
                        *ngTemplateOutlet="cardTemplate; context:{$implicit:'Passives', secondTitle:'',icon:'fa-face-meh text-zen-orange', value:enpsAnalysis?.PassivesCount, secondValue:enpsAnalysis?.PassivesPercentage | number:'1.1-1'}"></ng-container>
                </div>

                <div class="flex-1">
                    <ng-container
                        *ngTemplateOutlet="cardTemplate; context:{$implicit:'Detractors', secondTitle:'',icon:'fa-face-frown text-zen-red', value:enpsAnalysis?.DetractorsCount, secondValue:enpsAnalysis?.DetractorsCount}"></ng-container>
                </div>

            </div>
        </div>
        <zen-chart *ngIf="chartData && enpsAnalysis.ChartData?.length; else noData" [exportPageRows]="15"
            [data]="chartData" (exportPageLength)="exportPageLength.emit($event)">
            <ng-template #row let-row let-index="index" let-pageIndex="pageIndex">
                <div class="flex flex-row gap-5 w-full">
                    <div class="w-1/3">
                        <h5 class="text-sm text-zen  break-normal">{{row.category}}</h5>
                    </div>
                    <div class="flex flex-row justify-center w-2/3 gap-5">
                        <div
                            class="flex items-stretch flex-row h-4 rounded-lg overflow-hidden bg-zen bg-opacity-10 w-full">
                            <span *ngIf="row.values[0].value > 0" class="w-1/2"></span>
                            <div [ngClass]="row.values[0].value > 0?'justify-start':'justify-end'" class="flex w-1/2">
                                <div
                                    [style]="{width: (row.values[0].data?.absValue??0) + '%', backgroundColor:row.values[0].data?.itemStyle?.color}">
                                </div>
                            </div>
                        </div>
                        <h5 class="text-sm text-end text-zen w-18 truncate">{{row.values[0].value | number:'1.1-1'}}%
                        </h5>
                    </div>
                </div>
            </ng-template>
        </zen-chart>
        <ng-template #noData>
            <div class="w-full flex flex-col items-center justify-center gap-4 
                         px-8 py-14 border border-zen-neutralp90 bg-zen bg-opacity-10 rounded-lg">
                <i class="fa-light fa-chart-column text-5xl text-zen-neutralp70"></i>

                <h2 class="text-lg font-medium text-center text-zen-dark">
                    {{ "txt_Insuffici_103" | translate:language:ModuleNames.Engagement }}
                </h2>

                <p class="text-sm text-center text-primary-light">
                    {{ "txt_Theselect_919" | translate:language:ModuleNames.Engagement }}
                </p>
            </div>

        </ng-template>

    </div>
</div>

<ng-template #cardTemplate let-title let-secondTitle="secondTitle" let-icon="icon" let-value="value"
    let-secondValue="secondValue">
    <div
        class="flex flex-col items-stretch py-4 px-4 gap-2 h-full w-full border border-zen border-opacity-10 rounded-md bg-white text-zen">
        <div class="flex justify-between self-stretch items-center">
            <h6 class="text-zen-primaryLight text-xs font-medium flex items-center gap-1 capitalize">
                {{ title | translate:language:ModuleNames.Shared }}
            </h6>
            <ng-container *ngIf="secondTitle">
                <h5 class="text-xs text-zen-primaryLight">{{secondTitle | translate :language:ModuleNames.Shared}}</h5>
            </ng-container>


        </div>
        <div class="flex justify-between self-stretch items-center">
            <div class="text-zen-primaryDark text-2xl font-medium gap-2 flex flex-row items-center w-full">
                <i class="fa-regular" [ngClass]="icon"></i>
                <ng-container *ngIf="value">
                    {{value}}<p class="text-base text-zen-primaryDark font-normal"><span *ngIf="secondValue">({{
                            secondValue }}%)</span>
                </ng-container>
            </div>


        </div>
    </div>
</ng-template> -->